import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment-timezone';
import StarRatings from 'react-star-ratings';
import InputRange from 'react-input-range';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { submitHotelReview, closeModal } from '../../redux/actions';
import { Modal } from '../index';
import { Button } from '../../components';
import { Pool, Gym, Spa, Business } from '../../utils';

import {
  ReviewHeading,
  HotelInfoContainer,
  ProductName,
  HotelPhoto,
  HotelDate,
  HotelDescr,
  StepContainer,
  StepHeading,
  StepSubheading,
  ReviewStars,
  TextareaHeading,
  TextareaBox,
  AmenitiesList,
  Amenity,
  TwoOptionList,
  TwoOption,
  ReviewRangeContainer,
  Thanks,
} from './styles';

const mapStateToProps = state => ({
  hotel: state.bookingManagement.hotel,
  status: state.bookingManagement.status,
});

const mapDispatchToProps = dispatch => bindActionCreators({
  handleReviewSubmit: submitHotelReview,
  handleModalClose: closeModal,
}, dispatch);

@connect(mapStateToProps, mapDispatchToProps)
class ReviewModal extends Component {
  static propTypes = {
    hotel: PropTypes.instanceOf(Object),
    handleReviewSubmit: PropTypes.func,
    handleModalClose: PropTypes.func,
    status: PropTypes.string,
  };

  state = {
    step: 0,
    stars: {
      amount: 0,
      textReview: '',
    },
    amenities: [],
    food: {
      bought: 'no',
      amount: 98,
    },
    parking: {
      bought: 'no',
      amount: 10,
    },
    spa: {
      bought: 'no',
      amount: 100,
    },
    additional: {
      bought: 'no',
      amount: 20,
    },
  };

  componentDidMount() {
    const { hotel: { surveyFinished,
      surveyRating,
      rateCommend,
      usePool,
      useGym,
      useSpa,
      useBusinessCenter,
      isBuyFoodAndDrink,
      foodAndDrinkPrice,
      isPayForParking,
      parkingPrice,
      isBuySpaService,
      spaServicePrice,
      isBuyAdditionalService,
      additionalServicePrice, }} = this.props;

    if (surveyFinished) {

      const amenities = [];
      if (usePool) amenities.push('pool');
      if (useGym) amenities.push('gym');
      if (useSpa) amenities.push('spa');
      if (useBusinessCenter) amenities.push('business');
      this.setState({
        stars: {
          amount: surveyRating,
          textReview: rateCommend,
        },
        amenities,
        food: {
          bought: isBuyFoodAndDrink ? 'yes' : 'no',
          amount: isBuyFoodAndDrink ? foodAndDrinkPrice : 98,
        },
        parking: {
          bought: isPayForParking ? 'yes' : 'no',
          amount: isPayForParking ? parkingPrice : 10,
        },
        spa: {
          bought: isBuySpaService ? 'yes' : 'no',
          amount: isBuySpaService ? spaServicePrice : 100,
        },
        additional: {
          bought: isBuyAdditionalService ? 'yes' : 'no',
          amount: isBuyAdditionalService ? additionalServicePrice : 20,
        },

      })
    }
  };

  componentDidUpdate(prevProps, prevState) {
    const { step: newStep } = this.state;
    const { step } = prevState;

    if(step !== newStep) {
      this.submitReview();
    }
  };

  setStarsAmount = stars => {
    this.setState(prevState => ({
      ...prevState,
      stars: {
        ...prevState.stars,
        amount: stars,
      },
    }));
  };

  handleTextInput = evt => {
    const { target } = evt;

    this.setState(prevState => ({
      ...prevState,
      stars: {
        ...prevState.stars,
        textReview: target.value,
      },
    }));
  };

  handleAmenityClick = evt => {
    const { amenities } = this.state;
    const { target } = evt;
    const { value } = target;
    const amenitiesList = amenities;
    const containedOptionIndex = amenities.findIndex(option => option === value);

    if (containedOptionIndex !== -1) {
      amenitiesList.splice(containedOptionIndex, 1);
    } else {
      amenitiesList.push(value);
    }

    this.setState({
      amenities: amenitiesList,
    });
  };

  handleTwoOptionsClick = evt => {
    const { target } = evt;
    const { value, name } = target;

    this.setState(prevState => ({
      [name]: {
        ...prevState[name],
        bought: value,
      },
    }));
  };

  handleRangeValueChange = (value, name) => {
    this.setState(prevState => ({
      [name]: {
        ...prevState[name],
        amount: value,
      },
    }));
  };

  incrementCurrentStep = () => {
    this.setState(prevState => ({
      step: prevState.step + 1,
    }));
  };

  submitReview = () => {
    const { handleReviewSubmit, hotel: { bookingId } } = this.props;
    handleReviewSubmit(this.state, bookingId);
  };

  convertStarToText = amount => {
    switch (amount) {
      case 1:
        return 'Very Bad';
      case 2:
        return 'Bad';
      case 3:
        return 'Good';
      case 4:
        return 'Very Good';
      case 5:
        return 'Excellent';
      default:
        return 'How was it?';
    }
  };

  render() {
    const {
      setStarsAmount,
      convertStarToText,
      incrementCurrentStep,
      handleTextInput,
      handleAmenityClick,
      handleTwoOptionsClick,
      handleRangeValueChange,
    } = this;
    const { step, stars, amenities, food, parking, spa, additional } = this.state;
    const { hotel, handleModalClose, status } = this.props;
    const { hotelPicture, productName, neighborhood, hotelName, price, checkinDate } = hotel;

    const loader = () => (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className="loader"
        preserveAspectRatio="xMidYMid"
        style={{ width: '50px', height: '20px', 'margin-left': '5px' }}
        viewBox="0 0 68 14"
      >
        <g transform="translate(7 7)">
          <circle r="7" fill="#ffffff" transform="scale(0.8984)">
            <animateTransform
              attributeName="transform"
              begin="-0.375s"
              calcMode="spline"
              dur="1s"
              keySplines="0.3 0 0.7 1;0.3 0 0.7 1"
              keyTimes="0;0.5;1"
              repeatCount="indefinite"
              type="scale"
              values="0;1;0"
            />
          </circle>
        </g>
        <g transform="translate(27 7)">
          <circle r="7" fill="#ffffff" transform="scale(0.59269)">
            <animateTransform
              attributeName="transform"
              begin="-0.25s"
              calcMode="spline"
              dur="1s"
              keySplines="0.3 0 0.7 1;0.3 0 0.7 1"
              keyTimes="0;0.5;1"
              repeatCount="indefinite"
              type="scale"
              values="0;1;0"
            />
          </circle>
        </g>
        <g transform="translate(47 7)">
          <circle r="7" fill="#ffffff" transform="scale(0.2416)">
            <animateTransform
              attributeName="transform"
              begin="-0.125s"
              calcMode="spline"
              dur="1s"
              keySplines="0.3 0 0.7 1;0.3 0 0.7 1"
              keyTimes="0;0.5;1"
              repeatCount="indefinite"
              type="scale"
              values="0;1;0"
            />
          </circle>
        </g>
        <g transform="translate(67 7)">
          <circle r="7" fill="#ffffff" transform="scale(0.01308)">
            <animateTransform
              attributeName="transform"
              begin="0s"
              calcMode="spline"
              dur="1s"
              keySplines="0.3 0 0.7 1;0.3 0 0.7 1"
              keyTimes="0;0.5;1"
              repeatCount="indefinite"
              type="scale"
              values="0;1;0"
            />
          </circle>
        </g>
      </svg>
    );

    const renderStarsStep = () => (
      <StepContainer>
        <StepHeading>{convertStarToText(stars.amount)}</StepHeading>
        <ReviewStars>
          <StarRatings
            rating={stars.amount}
            numberOfStars={5}
            changeRating={setStarsAmount}
            starRatedColor="#1eb6ff"
            starHoverColor="#1eb6ff"
            starEmptyColor="#ffffff"
            starSpacing="4px"
            starDimension="30px"
          />
        </ReviewStars>
        {stars.amount > 0 && (
          <Fragment>
            <TextareaHeading>Please tell us how was your experience?</TextareaHeading>
            <TextareaBox onChange={handleTextInput} value={stars.textReview} />
            <Button htmlType="button" theme="primary" onClick={incrementCurrentStep} disabled={status ==='fetching'}>
              Next
              {status === 'fetching' && loader()}
            </Button>
          </Fragment>
        )}
      </StepContainer>
    );

    const renderAmenitiesStep = () => (
      <StepContainer>
        <StepHeading>What did you use?</StepHeading>
        <AmenitiesList>
          <li>
            <Amenity
              type="button"
              value="pool"
              onClick={handleAmenityClick}
              isActive={amenities.includes('pool')}
            >
              <Pool />
              Pool
            </Amenity>
          </li>
          <li>
            <Amenity
              type="button"
              value="spa"
              onClick={handleAmenityClick}
              isActive={amenities.includes('spa')}
            >
              <Spa />
              Spa
            </Amenity>
          </li>
          <li>
            <Amenity
              type="button"
              value="gym"
              onClick={handleAmenityClick}
              isActive={amenities.includes('gym')}
            >
              <Gym />
              Gym
            </Amenity>
          </li>
          <li>
            <Amenity
              type="button"
              value="business"
              onClick={handleAmenityClick}
              isActive={amenities.includes('business')}
            >
              <Business />
              Business center
            </Amenity>
          </li>
        </AmenitiesList>
        <Button htmlType="button" theme="primary" onClick={incrementCurrentStep} disabled={status ==='fetching'}>
          Next
          {status === 'fetching' && loader()}
        </Button>
      </StepContainer>
    );

    const renderFoodStep = () => (
      <StepContainer>
        <StepHeading>Did you buy any food & drink?</StepHeading>
        <TwoOptionList>
          <li>
            <TwoOption
              type="button"
              name="food"
              value="yes"
              onClick={handleTwoOptionsClick}
              isActive={food.bought === 'yes'}
            >
              Yes
            </TwoOption>
          </li>
          <li>
            <TwoOption
              type="button"
              name="food"
              value="no"
              onClick={handleTwoOptionsClick}
              isActive={food.bought === 'no'}
            >
              No
            </TwoOption>
          </li>
        </TwoOptionList>
        {food.bought === 'yes' && (
          <ReviewRangeContainer>
            <InputRange
              minValue={10}
              maxValue={1000}
              value={food.amount}
              onChange={value => handleRangeValueChange(value, 'food')}
              formatLabel={val => `$${val}`}
            />
          </ReviewRangeContainer>
        )}
        <Button htmlType="button" theme="primary" onClick={incrementCurrentStep} disabled={status ==='fetching'}>
          Next
          {status === 'fetching' && loader()}
        </Button>
      </StepContainer>
    );

    const renderParkingStep = () => (
      <StepContainer>
        <StepHeading>Did you have to pay for parking?</StepHeading>
        <TwoOptionList>
          <li>
            <TwoOption
              type="button"
              name="parking"
              value="yes"
              onClick={handleTwoOptionsClick}
              isActive={parking.bought === 'yes'}
            >
              Yes
            </TwoOption>
          </li>
          <li>
            <TwoOption
              type="button"
              name="parking"
              value="no"
              onClick={handleTwoOptionsClick}
              isActive={parking.bought === 'no'}
            >
              No
            </TwoOption>
          </li>
        </TwoOptionList>
        {parking.bought === 'yes' && (
          <ReviewRangeContainer>
            <InputRange
              minValue={10}
              maxValue={1000}
              value={parking.amount}
              onChange={value => handleRangeValueChange(value, 'parking')}
              formatLabel={val => `$${val}`}
            />
          </ReviewRangeContainer>
        )}
        <Button htmlType="button" theme="primary" onClick={incrementCurrentStep} disabled={status ==='fetching'}>
          Next
          {status === 'fetching' && loader()}
        </Button>
      </StepContainer>
    );

    const renderSpaStep = () => (
      <StepContainer>
        <StepHeading>Did you buy any spa services?</StepHeading>
        <TwoOptionList>
          <li>
            <TwoOption
              type="button"
              name="spa"
              value="yes"
              onClick={handleTwoOptionsClick}
              isActive={spa.bought === 'yes'}
            >
              Yes
            </TwoOption>
          </li>
          <li>
            <TwoOption
              type="button"
              name="spa"
              value="no"
              onClick={handleTwoOptionsClick}
              isActive={spa.bought === 'no'}
            >
              No
            </TwoOption>
          </li>
        </TwoOptionList>
        {spa.bought === 'yes' && (
          <ReviewRangeContainer>
            <InputRange
              minValue={10}
              maxValue={1000}
              value={spa.amount}
              onChange={value => handleRangeValueChange(value, 'spa')}
              formatLabel={val => `$${val}`}
            />
          </ReviewRangeContainer>
        )}
        <Button htmlType="button" theme="primary" onClick={incrementCurrentStep} disabled={status ==='fetching'}>
          Next
          {status === 'fetching' && loader()}
        </Button>
      </StepContainer>
    );

    const renderAdditionalStep = () => (
      <StepContainer>
        <StepHeading>Did you buy any additional services?</StepHeading>
        <TwoOptionList>
          <li>
            <TwoOption
              type="button"
              name="additional"
              value="yes"
              onClick={handleTwoOptionsClick}
              isActive={additional.bought === 'yes'}
            >
              Yes
            </TwoOption>
          </li>
          <li>
            <TwoOption
              type="button"
              name="additional"
              value="no"
              onClick={handleTwoOptionsClick}
              isActive={additional.bought === 'no'}
            >
              No
            </TwoOption>
          </li>
        </TwoOptionList>
        {additional.bought === 'yes' && (
          <ReviewRangeContainer>
            <InputRange
              minValue={10}
              maxValue={1000}
              value={additional.amount}
              onChange={value => handleRangeValueChange(value, 'additional')}
              formatLabel={val => `$${val}`}
            />
          </ReviewRangeContainer>
        )}
        <Button htmlType="button" theme="primary" onClick={incrementCurrentStep} disabled={status ==='fetching'}>
          Next
          {status === 'fetching' && loader()}
        </Button>
      </StepContainer>
    );

    const renderFinalStep = () => (
      <StepContainer>
        <StepHeading>Thank you!</StepHeading>
        <StepSubheading>Your feedback has been recorded!</StepSubheading>
        <Thanks>Thanks again for using DayAxe!</Thanks>
        <Button htmlType="button" theme="primary" onClick={handleModalClose}>
          Done
        </Button>
      </StepContainer>
    );

    return (
      <Modal empty noButton>
        <ReviewHeading>
          Your Last Stay
          <span>${price}</span>
        </ReviewHeading>
        <HotelInfoContainer>
          <HotelPhoto>
            <img src={`${process.env.CDN_URL}${hotelPicture}`} alt={hotelName} />
          </HotelPhoto>
          <div>
            <ProductName>{productName}</ProductName>
            <HotelDescr>{hotelName}</HotelDescr>
            <HotelDescr>{neighborhood}</HotelDescr>
            <HotelDate>{moment(checkinDate).format('MMM DD, YYYY')}</HotelDate>
          </div>
        </HotelInfoContainer>
        {step === 0 && renderStarsStep()}
        {step === 1 && renderAmenitiesStep()}
        {step === 2 && renderFoodStep()}
        {step === 3 && renderParkingStep()}
        {step === 4 && renderSpaStep()}
        {step === 5 && renderAdditionalStep()}
        {step === 6 && renderFinalStep()}
      </Modal>
    );
  }
}

export default ReviewModal;
